'use client';

import React, { ReactEventHandler, useState } from 'react';
import { Flex } from '../Flex';
import { Typography } from '../Typography';
import { Vote } from '../../constants';
import { ThumbsButton } from '../ThumbsButton/ThumbsButton';
export type AdviceCardActionHandler = ReactEventHandler<HTMLButtonElement>;
type Props = Record<'onClickYes' | 'onClickNo', AdviceCardActionHandler>;
export const ArticleAdviceCardActions = ({
  onClickYes,
  onClickNo
}: Props) => {
  const [voteType, setVoteType] = useState(null);
  const handleOnClickYes = event => {
    setVoteType(Vote.Yes);
    onClickYes(event);
  };
  const handleOnClickNo = event => {
    setVoteType(Vote.No);
    onClickNo(event);
  };
  return <>
      <Flex justifyContent="space-between" alignItems="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Typography variant="body2" lineHeight="1.5" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Was this question and answer helpful?
        </Typography>
        <Flex ml="20px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <ThumbsButton direction="up" active={voteType === Vote.Yes} onClick={voteType !== Vote.Yes && handleOnClickYes} data-sentry-element="ThumbsButton" data-sentry-source-file="index.tsx" />
          <ThumbsButton direction="down" active={voteType === Vote.No} ml="10px" onClick={voteType !== Vote.No && handleOnClickNo} data-sentry-element="ThumbsButton" data-sentry-source-file="index.tsx" />
        </Flex>
      </Flex>
      {/*
       * TODO: Hide the comment button for now.
       * Check https://wagsters.atlassian.net/browse/NV-3189 for a detailed description
       * related to https://wagsters.atlassian.net/browse/NV-2711
       */}
      {/* <Flex
       justifyContent="center"
       >
       <Button
        variant="contained"
        size="large"
        mt={['16px', '16px', 0]}
       >
        Comment
       </Button>
       </Flex> */}
    </>;
};
export type ArticleAdviceCardActionsProps = Props;